<template>
  <v-card-actions>
    <v-btn
      :disabled="internalValue === 0"
      class="white--text"
      color="grey darken-2"
      @click="$emit('click:prev')"
    >
      <span
        class="d-none d-sm-flex"
      >
        Previous
      </span>
      <span
        class="d-flex d-sm-none"
      >
        <v-icon>mdi-arrow-left-thick</v-icon>
      </span>
    </v-btn>

    <v-spacer />

    <slot name="buttons" />

    <v-spacer />

    <v-btn
      :disabled="!availableSteps.includes(internalValue + 1)"
      :color="color"
      @click="$emit('click:next')"
    >
      <span
        class="d-none d-sm-flex"
      >
        {{ internalValue === items.length - 1 ? 'Finish' : 'Next' }}
      </span>
      <span
        class="d-flex d-sm-none"
      >
        <v-icon
          v-if="internalValue === items.length - 1"
        >
          mdi-check-outline
        </v-icon>
        <v-icon
          v-if="internalValue !== items.length - 1"
        >
          mdi-arrow-right-thick
        </v-icon>
      </span>
    </v-btn>
  </v-card-actions>
</template>

<script>
  export default {
    name: 'BaseWizardActions',

    props: {
      internalValue: {
        type: Number,
        default: 0,
      },
      color: {
        type: String,
        default: 'success',
      },
      availableSteps: {
        type: Array,
        default: () => ([]),
      },
      items: {
        type: Array,
        default: () => ([]),
      },
    },
  }
</script>
